import React, { useState } from "react";
import { Pagination } from "@mui/material";
import AuthService from "../../Components/auth/AuthService";
import {
  useLoadingDispatch,
  showLoading,
  hideLoading,
} from "../../context/loadingContext";
import { Button, Card, Col, Flex, Input, message, Modal, Row, Space, Table } from "antd/es";
import { DeleteFilled, EditFilled, EditTwoTone, FilterOutlined, PlusCircleFilled, SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Message from "../../Components/common/Message";
import { showMessage } from "../../Components/Utils/message";
import { useSelector } from "react-redux";
import { encodeId } from "../../Components/common/CommonFun";
import { styled } from "@mui/system";
const DataSheet = styled('div')`
   .ant-card-body {
      padding: 10px;
    };
    .ant-card-head {
      min-height: 40px;
    };
`;

const Auth = new AuthService();
const { Search } = Input;

export default function AisleList() {
  const { type: roleType, roles } = useSelector((state) => state?.AppState?.userCreds);
  var layoutDispatch = useLoadingDispatch();
  const navigate = useNavigate();

  const [aisles, setAisles] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [totalCount, setTotalCount] = React.useState(null);
  const [limit] = React.useState(50);

  const [loadMessage, setLoadMessage] = React.useState("");
  const [type, setType] = React.useState("");

  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const aisleColumns = [

    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Levels',
      render: (record) => {
        return (
          <>{record?.levels.toLocaleString()}</>
        )
      }
    },
    {
      title: 'Depth (Pallets)',
      render: (record) => {
        return (
          <>{record?.depth.toLocaleString()}</>
        )
      }
    },
    {
      title: 'Total Locations',
      dataIndex: 'total_locations',
      key: 'total_locations',
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: '',
      align: "right",
      render(record) {
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <EditFilled onClick={() => handleRowClick(record.id)} style={{ fontSize: '25px', cursor: "pointer", marginRight: "5px", color: "#001529" }} />
            {canAccess &&
              <DeleteFilled style={
                {
                  fontSize: "25px",
                  cursor: "pointer",
                  color: "#cd1437",
                }} onClick={() => {
                  Modal.confirm({
                    title: 'Delete Aisle',
                    centered: true,
                    content: `Are you sure you want to delete this aisle?`,
                    onOk: () => deleteAisle(record.id),
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    width: 600,
                    okButtonProps: { size: "large" },
                    cancelButtonProps: { size: "large" },
                  });
                }}
              />
            }

          </div>
        );
      },
    },
  ];

  const deleteAisle = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/aisle/aisle`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getAllAisles();
        showMessage("success", res?.message);
      } else {
        showMessage("error", res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage("error", "Something went wrong while deleting the aisle.");
    } finally {
      hideLoading(layoutDispatch);
    }
  };


  const getAllAisles = async (clear) => {
    showLoading(layoutDispatch)
    const dataToSend = {
      limit: limit,
      page: page,
    }
    if (searchText) dataToSend.searchText = searchText?.trim();
    try {
      const res = await Auth.post(`/aisle/aisles`, dataToSend);
      if (res.ack) {
        setAisles(res.aisles)
        setTotalPages(Math.ceil(res.total_count / limit));
        setTotalCount(res?.total_count);

      } else {
        showMessage("error", res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage("error", "Something went wrong while fetching aisles.");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  React.useEffect(() => {
    getAllAisles()
  }, [page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleRowClick = (id) => {
    const hasedID = encodeId(id)
    navigate(`/aisles/${hasedID}`)

  };

  return (
    <DataSheet>
      <Card title={<><FilterOutlined style={{ color: '#6cb8ff' }} /> Aisles</>}
        style={{ marginBottom: '10px' }}
        extra={
          <>
            {canAccess && <PlusCircleFilled style={{ fontSize: "30px", color: "#006cb8" }} onClick={() => navigate("/aisles/new")} />}
          </>
        }
      >
        <Row gutter={[6, 1]}>
          <Col xs={24} md={12} lg={6} xl={5}>
            <Input
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              
              placeholder='Search Aisle'
              style={{ width: "100%" }}
              allowClear
            />
          </Col>
          <Col xs={24} md={12} lg={4} xl={4}>
            <Space style={{ width: '100%'}}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={getAllAisles}
              >
                Search
              </Button>
            </Space>
          </Col>
        </Row>
      </Card>

      <div >
        <Table
          columns={aisleColumns}
          style={{ overflowX: "auto" }}
          dataSource={aisles}
          pagination={false}
          // footer={()=>`List of Aisle - Total Records: ${aisles.length === 0 ? "0" : aisles.length  }`}
          footer={() => {
            const startRecord = (page - 1) * limit + 1;
            const endRecord = Math.min(page * limit, aisles.length ? totalCount : 0);
            return `Showing ${startRecord}-${endRecord} of ${aisles.length ? totalCount : "0"} Records`;
          }}
          scroll={{ x: 'max-content' }}
          rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
        />
      </div>
      <Message type={type} msg={loadMessage} />
      <div style={{ float: "right", margin: "10px" }}>
        <Pagination
          page={page}
          count={totalPages}
          variant="outlined"
          color="primary"
          onChange={handleChange}
        />
      </div>

    </DataSheet>
  );
}
